const fontFamily = '\'Lato\', sans-serif'

export const styles = theme => ({
	root: {
		fontFamily: fontFamily,
		'&$checked': {
			color: '#358ed7',
		},
	},
	checked: {},
	textField: {
		fontFamily: fontFamily,
		width: '100%',
		marginTop: 0,
	},
	flexRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	urlForm: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-end',
		flex: 1,
	},
	tooltip: {
		fontSize: 14
	},

})
